export const ru = {
    'add-creatives': 'Добавить выбранные',
    'cancel-and-return': 'Отмена'
};
